import Route from "@/generated/classes/Route";

export class NavigationItem {
  public module: string;
  public route: Route | null;
  public picto: string;
  public order: number;
  public title: string;
  public childs: NavigationItem[];
}